// extracted by mini-css-extract-plugin
export var chevronIcon = "_sc-1";
export var edgeToggle = "_sc-0";